import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Zap, CreditCard } from 'lucide-react';
import { Button } from '../ui/Button';
export const PurchaseSection = ({
  id = 'comprar'
}: {
  id?: string;
}) => {
  return <section id={id} className="py-16 px-4 bg-gray-900 border-y border-orange-900/50" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-209">
            💳 ELEGÍ TU COMBO
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-210"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-211">
          {/* Oferta Básica */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-black border-2 border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col relative" data-id="element-212">
            <div className="text-center mb-6" data-id="element-213">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-214">
                📘 COCINA RESUELTA COMPLETO
              </h3>
              <p className="text-orange-500 font-bold" data-id="element-215">5 Tomos + 5 Bonos</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-216">
              {['90+ recetas completas', '5 bonos estratégicos', 'Acceso inmediato', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-217">
                  <Check className="w-5 h-5 text-orange-500 flex-shrink-0" data-id="element-218" />
                  <span className="text-gray-300 font-medium" data-id="element-219">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6" data-id="element-220">
              <p className="text-gray-500 line-through text-lg mb-1" data-id="element-221">
                Antes: $51.900
              </p>
              <p className="text-orange-500 font-bold uppercase tracking-widest text-sm mb-1" data-id="element-222">
                Hoy
              </p>
              <p className="text-5xl font-extrabold text-white" data-id="element-223">
                $19.990 <span className="text-xl text-gray-400" data-id="element-224">ARS</span>
              </p>
            </div>

            <Button href="https://www.compradigitalya.com/cart/42853224349767:1" data-id="element-225">
              👉 QUIERO MI COCINA RESUELTA AHORA
            </Button>
          </motion.div>

          {/* Oferta Premium */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-black border-4 border-orange-500 rounded-2xl p-6 md:p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(249,115,22,0.2)]" data-id="element-226">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-orange-500 text-white font-black uppercase tracking-widest py-1 px-6 rounded-full text-sm shadow-lg whitespace-nowrap" data-id="element-227">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-228">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-229">
                🏆 COCINA RESUELTA + POSTRES
              </h3>
              <p className="text-orange-500 font-bold" data-id="element-230">
                5 Tomos + 5 Bonos + Postres Resueltos
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-231">
              {['Todo el Combo Completo', '16 recetas de postres', '10 clásicos argentinos', '6 postres fit sin azúcar refinada', 'Guía de maridajes mate y café'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-232">
                  <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-233" />
                  <span className="text-white font-bold" data-id="element-234">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6" data-id="element-235">
              <p className="text-gray-500 line-through text-lg mb-1" data-id="element-236">
                Antes: $76.900
              </p>
              <p className="text-orange-500 font-bold uppercase tracking-widest text-sm mb-1" data-id="element-237">
                Hoy
              </p>
              <p className="text-5xl font-extrabold text-white" data-id="element-238">
                $27.990 <span className="text-xl text-gray-400" data-id="element-239">ARS</span>
              </p>
            </div>

            <Button href="https://www.compradigitalya.com/cart/42853226315847:1" className="shadow-[0_0_20px_rgba(249,115,22,0.4)]" data-id="element-240">
              👉 QUIERO EL COMBO COMPLETO CON POSTRES
            </Button>
          </motion.div>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-6 text-gray-400 text-sm font-medium" data-id="element-241">
          <div className="flex items-center gap-2" data-id="element-242">
            <Shield className="w-5 h-5 text-orange-500" data-id="element-243" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-244">
            <Zap className="w-5 h-5 text-orange-500" data-id="element-245" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2" data-id="element-246">
            <CreditCard className="w-5 h-5 text-orange-500" data-id="element-247" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
};